
/**
 * Компонент для фильтров, который появляется в мобильной версии
 */
import { ref } from '@vue/composition-api';
import type { BaseFilter } from '~/type/Filter';
interface Props {
  placeholder: string;
  width: '116px' | '135px';
  fontSize: '14px' | '16px' | '18px';
  icon: 'filter' | 'arrow';
  list: BaseFilter[];
  value?: BaseFilter;
}
const __sfc_main = {};
__sfc_main.props = {
  placeholder: {
    key: "placeholder",
    required: true,
    type: String
  },
  width: {
    key: "width",
    required: false,
    type: String,
    default: '135px'
  },
  fontSize: {
    key: "fontSize",
    required: false,
    type: String,
    default: '14px'
  },
  icon: {
    key: "icon",
    required: false,
    type: String,
    default: 'filter'
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isSelectOption = ref(false);
  function onSelect(e: Event) {
    isSelectOption.value = true;
    const val = (e?.target as HTMLSelectElement).value;
    const el = props.list.find((el: BaseFilter) => el.value === val) || undefined;
    /**
     * Срабатывает при выборе/изменении фильтра
    */
    emit('change', el);
  }
  return {
    onSelect
  };
};
export default __sfc_main;
